import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import GamesListPage from "@/pages/GamesListPage";
import GameDetailPage from "@/pages/GameDetailPage";
import StorePage from "@/pages/StorePage";
import { CartProvider, CartDrawer } from "@/components/Cart";
import CinematicTour from "@/components/CinematicTour";
import AmbientBackground from "@/components/AmbientBackground";
import AnnouncementRibbon from "@/components/AnnouncementRibbon";
import MaintenanceScreen from "@/components/MaintenanceScreen";
import data from "@/data.json";

function useRibbonActive(endISO) {
  const [active, setActive] = useState(() => {
    if (!endISO) return false;
    return new Date() < new Date(endISO);
  });
  useEffect(() => {
    if (!endISO || !active) return;
    const id = setInterval(() => {
      if (new Date() >= new Date(endISO)) {
        setActive(false);
      }
    }, 5000);
    return () => clearInterval(id);
  }, [endISO, active]);
  return active;
}

function App() {
  useEffect(() => {
    document.title = "Ashvolt Studios — The Protocol Lite";
  }, []);

  const ribbonActive = useRibbonActive(data.announcement?.endISO);

  return (
    <BrowserRouter>
      <CartProvider>
        {data.announcement && ribbonActive && (
          <AnnouncementRibbon data={data.announcement} />
        )}
        <SmoothScroll>
          <AmbientBackground />
          <div className="grain" aria-hidden="true" />
          <div className="relative z-10 min-h-screen text-white overflow-x-hidden">
            <Header data={data} ribbonActive={ribbonActive} />
            <main>
              <Routes>
                <Route path="/" element={<HomePage data={data} />} />
                <Route path="/games" element={<GamesListPage data={data} />} />
                <Route path="/games/:id" element={<GameDetailPage data={data} />} />
                <Route path="/store" element={<StorePage data={data} />} />
              </Routes>
            </main>
            <Footer data={data.footer} brand={data.brand} />
            <CinematicTour />
          </div>
          <Toaster theme="dark" position="bottom-right" />
          <CartDrawer />
          {data.announcement && data.announcement.endISO && (
            <MaintenanceScreen data={data.announcement} />
          )}
        </SmoothScroll>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
